import { Navigate, Outlet, createFileRoute, useRouterState } from "@tanstack/react-router";

import { Route as UpdatesLocalityByIdRoute } from "src/app/routes/updates.regions.$regionId_.localities.$localityId";
import { routeMatches } from "src/lib/vendor/tanstack/reactRouter/utils";

export const Route = createFileRoute(
  "/updates/regions/$regionId/localities/$localityId/locations"
)({
  beforeLoad({ params }) {
    return { pageName: params.localityId };
  },

  component: RouteComponent
});

export function RouteComponent() {
  const { matches } = useRouterState();

  if (routeMatches(matches, "/updates/regions/$regionId/localities/$localityId/locations")) {
    return <Navigate to={UpdatesLocalityByIdRoute.id} replace params />;
  }

  return <Outlet />;
}
